/** 广场列表/详情名称：租户空间/制品名称 */
export function formatPlazaArtifactDisplayName(item: { workspace?: string; name?: string }): string {
  const name = (item.name ?? '').trim();
  const workspace = (item.workspace ?? '').trim();
  if (workspace && name) {
    return `${workspace}/${name}`;
  }
  return name || workspace || '-';
}
